import PdfDashboards from "ToddleAnalytics/routes/PdfDashboards";

export default store => ({
  path: "pinned",
  childRoutes: [PdfDashboards(store)],
});
